module.exports = __webpack_public_path__ + "GreenStrategy.8639f94.png";